import React from 'react';
import PropTypes from 'prop-types';

import { Form, FormControl, FormGroup } from 'react-bootstrap-5';

export default class FilterInput extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any,
        value: PropTypes.any,
        label: PropTypes.any,
      })
    ),
  };

  render() {
    return (
      <FormGroup className="d-flex flex-column gap-1">
        <Form.Label>{this.props.label}</Form.Label>
        {this.renderInput()}
      </FormGroup>
    );
  }

  renderInput() {
    const { label, placeholder, ...otherProps } = this.props;
    return <FormControl placeholder={placeholder || label} {...otherProps} />;
  }
}
